<template>
  <div class="InvoiceBusinessNameField">
    <input type="text" class="form-control" @keydown.stop @keydown.enter="handleChange" @change="handleChange" :placeholder="placeholder" v-model="computedBusinessName" :disabled="isSaving">
  </div>
</template>

<script>

import { mapActions } from 'vuex';
export default {
  props: {
    quoteRecId:  { type: String, required: true },
    businessName: { type: String, required: true }
  },
  data() {
    return {
      isSaving: false,
      placeholder: window.vue.translations.label.label_col_customer,
      computedBusinessName: this.businessName 
    }
  },
  watch: {
    businessName (val) {
      this.computedBusinessName = val;
    }
  },
  methods: {
    ...mapActions('quotations', ['saveInvoiceBusinessName']),
    handleChange() {
      this.isSaving = true;
      var payload = { quoteRecId: this.quoteRecId, businessName: this.computedBusinessName }

      this.saveInvoiceBusinessName(payload).then(_ => {
        this.isSaving = false;
      });
    }
  }
}
</script>
